import { useMe } from './hooks/graphql.js';
export const featureFlags = {
    hub: false,
};
export function useFeatureFlag(flag) {
    var _a, _b, _c, _d;
    const result = useMe();
    return (featureFlags[flag] || ((_d = (_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.me) === null || _b === void 0 ? void 0 : _b.plan) === null || _c === void 0 ? void 0 : _c.featureFlags) === null || _d === void 0 ? void 0 : _d.includes(flag)));
}
//# sourceMappingURL=featureFlags.js.map